module.exports = __webpack_public_path__ + "media/images/icons/credit_card_back-f1df1fd4fbf354dad10172c83e701c8f.svg";